// @flow
import api from 'tim-api';
import {
  views as viewsEndpoint,
  viewsSigTim as viewsSigTimEndpoint,
  viewGoals as viewGoalsEndPoint,
  vendaCantadaRegionais as viewSaleEndPoint
} from 'endPoints';

export const state: Object = {
  views: []
};

export const getters = {
  views: (state: Object) => state.views
};

export const mutations = {
  SET_VIEWS(state: Object, views: Array<Object>) {
    state.views = views;
  }
};

export const actions = {
  fetchViews({ commit }: Action) {
    return api.get(viewsEndpoint).then(({ data }) => {
      commit('SET_VIEWS', data.data);
    });
  },
  fetchViewsSigtim({ commit }: Action) {
    return api.get(viewsSigTimEndpoint).then(({ data }) => {
      commit('SET_VIEWS', data.data);
    });
  },
  fetchViewsRelated({ commit }: Action) {
    return api.get(`${viewsEndpoint}/related`).then(({ data }) => {
      commit('SET_VIEWS', data.data);
    });
  },
  fetchViewsGoals({ commit }: Action) {
    return api.get(viewGoalsEndPoint).then(({ data }) => {
      commit('SET_VIEWS', data);
    });
  },
  fetchViewsSale({ commit }: Action) {
    return api.get(viewSaleEndPoint).then(({ data }) => {
      commit('SET_VIEWS', data);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
